export const SITE_REQUEST_ERROR_NAME = 'SiteAxiosInterceptorError';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function isSiteRequestError(error: unknown): boolean {
  return isRecord(error) && error.name === SITE_REQUEST_ERROR_NAME;
}

export function getSiteRequestHttpStatus(error: unknown): number | undefined {
  if (!isSiteRequestError(error) || !isRecord(error)) return undefined;
  const { response } = error;
  if (!isRecord(response)) return undefined;
  return typeof response.status === 'number' ? response.status : undefined;
}
